mutation StoreIntegrationCredentials(
  $integrationType: String!
  $apiKey: String!
  $apiUrl: String!
  $clientId: String!
  $clientSecret: String!
) {
  integrationId: storeIntegrationCredentials(
    integrationType: $integrationType
    apiKey: $apiKey
    apiUrl: $apiUrl
    clientId: $clientId
    clientSecret: $clientSecret
  )
}
